var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.settings.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.settings.message.username") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isEditPage
                    ? _c("BaseInput", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.$v.input.username.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.input.username, "$model", $$v)
                          },
                          expression: "$v.input.username.$model"
                        }
                      })
                    : _c("BaseInput", {
                        attrs: {
                          classNames: [
                            "text-lowercase",
                            {
                              "is-invalid": _vm.$v.input.username.$error,
                              "is-valid": _vm.$v.input.username.isUnique
                            }
                          ],
                          invalidText: _vm.username.invalidText,
                          validText: _vm.username.validText,
                          disabled: _vm.disabled,
                          placeholder: _vm.$t(
                            "apps.settings.placeholder.username"
                          ),
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.$v.input.username.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.input.username, "$model", $$v)
                          },
                          expression: "$v.input.username.$model"
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.settings.message.password") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _vm.isEditPage
                    ? _c("BaseInput", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.$v.input.password.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.input.password, "$model", $$v)
                          },
                          expression: "$v.input.password.$model"
                        }
                      })
                    : _c("BaseInput", {
                        attrs: {
                          classNames: [
                            {
                              "is-invalid": _vm.$v.input.password.$error,
                              "is-valid":
                                !_vm.$v.input.password.$error &&
                                _vm.$v.input.password.$model
                            }
                          ],
                          disabled: _vm.disabled,
                          placeholder: _vm.$t(
                            "apps.settings.placeholder.password"
                          ),
                          type: "password",
                          autocomplete: "new-password"
                        },
                        model: {
                          value: _vm.$v.input.password.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.input.password, "$model", $$v)
                          },
                          expression: "$v.input.password.$model"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.settings.message.setpermissions") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseRadioRich", {
                    attrs: {
                      val: _vm.USER_PERMISSION_TYPE.GENERAL,
                      label: _vm.$t("apps.settings.message.radiotypegeneral"),
                      message: _vm.$t(
                        "apps.settings.message.radiotypegeneraldetail"
                      ),
                      disabled: false
                    },
                    model: {
                      value: _vm.input.type,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "type", $$v)
                      },
                      expression: "input.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseRadioRich", {
                    attrs: {
                      val: _vm.USER_PERMISSION_TYPE.RELATIONAL,
                      label: _vm.$t(
                        "apps.settings.message.radiotyperelational"
                      ),
                      message: _vm.$t(
                        "apps.settings.message.radiotyperelationaldetail"
                      ),
                      disabled: false
                    },
                    model: {
                      value: _vm.input.type,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "type", $$v)
                      },
                      expression: "input.type"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  _c("SectionTitle", {
                    attrs: {
                      title: _vm.$t("apps.settings.message.setpermission")
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.input.type === _vm.USER_PERMISSION_TYPE.GENERAL
                ? _c(
                    "Col",
                    {
                      staticStyle: { "margin-top": "-20px" },
                      attrs: { className: "col-lg-12" }
                    },
                    [
                      _c("BaseRolePermission", {
                        attrs: {
                          masterData: _vm.appRolePermissions,
                          data: _vm.input.permissions
                        },
                        on: {
                          "update:data": function($event) {
                            return _vm.$set(_vm.input, "permissions", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm.input.type === _vm.USER_PERMISSION_TYPE.RELATIONAL
                ? _c(
                    "Col",
                    {
                      staticStyle: { "margin-top": "-15px" },
                      attrs: { className: "col-lg-12" }
                    },
                    [
                      !_vm.rolePermissionList.length
                        ? _c("BaseNotFoundData", {
                            attrs: {
                              title: _vm.$t(
                                "apps.settings.message.notfoundrolepermission"
                              ),
                              detail: _vm.$t(
                                "apps.settings.message.createnewrolepermission"
                              )
                            }
                          })
                        : _c("BaseSelectRolePermission", {
                            attrs: {
                              rolePermissionList: _vm.rolePermissionList,
                              selected: _vm.input.permissionIds
                            },
                            on: {
                              "update:selected": function($event) {
                                return _vm.$set(
                                  _vm.input,
                                  "permissionIds",
                                  $event
                                )
                              }
                            }
                          })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseFormAction", {
        attrs: {
          textCancel: _vm.$t("button.cancel"),
          textSubmit: _vm.$t("button.save"),
          isSubmitted: _vm.isSubmitted
        },
        on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8d5cc44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8d5cc44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/UserPermissionForm.vue
// module id = null
// module chunks = 